<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col md="2" style="padding:0">
            <Menu/>
          </b-col>
          <b-col md="10" style="padding:0" align="center">
            <div style="margin-left:15px;margin-top:15px;text-align:left;position:relative;bottom:10px">         
              <template>
                <b-dropdown left split text="language" class="language-dropdown" toggle-class="toggle-language" split-class="split-language" style="font-size: 12px;">
                  <template #button-content>
                    <img
                      :src="currentLanguageFlag"
                      style="width:28px; height:19px; border-radius:2px;"
                    >
                  </template>

                  <!-- Dropdown Items -->
                  <b-dropdown-item @click="selectLanguage('en')">
                    <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                    English
                  </b-dropdown-item>
                  <b-dropdown-item  @click="selectLanguage('fr')">
                    <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                    Français (French)
                  </b-dropdown-item>
                  <b-dropdown-item  @click="selectLanguage('de')">
                    <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                    Deutsch (German)
                  </b-dropdown-item>
                  <b-dropdown-item  @click="selectLanguage('es')">
                    <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                    Español (Spanish)
                  </b-dropdown-item>
                  <b-dropdown-item  @click="selectLanguage('it')">
                    <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                    Italiano (Italian)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('nl')">
                    <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                    Nederlands (Dutch)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('pt')">
                    <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                    Português (Portuguese)
                  </b-dropdown-item>                    
                </b-dropdown>
              </template>
            </div>
            <div style="height:100x">
            </div>
            <div class="w-box" style="width:60%">
              <p class="w-subtitle" style="text-align:right">{{ translate("web and social media") }}</p>
              <b-form autocomplete="false">
                <b-form-group style="text-align:left">
                  <label class="w-label" for="input-webpage">{{ translate("webpage") }}</label>
                  <b-form-input
                  id="input-webpage"
                  class="w-input"
                  v-model="form.webpage"
                  v-bind:class="{'is-invalid' : !this.webpageValid}"
                  aria-describedby="input-live-help input-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-live-feedback">
                    {{webpageFeedback}}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group style="text-align:left">
                  <label class="w-label" for="input-facebook">facebook</label>
                  <b-form-input
                  id="input-facebook"
                  class="w-input"
                  v-model="form.facebook"
                  v-bind:class="{'form-control':true, 'is-invalid' : !this.facebookValid}"
                  aria-describedby="input-live-help input-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-live-feedback">
                    {{facebookFeedback}}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group style="text-align:left">
                  <label class="w-label" for="input-twitter">twitter</label>
                  <b-form-input
                  id="input-twitter"
                  class="w-input"
                  v-model="form.twitter"
                  v-bind:class="{'form-control':true, 'is-invalid' : !this.twitterValid}"
                  aria-describedby="input-live-help input-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-live-feedback">
                    {{twitterFeedback}}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group style="text-align:left">
                  <label class="w-label" for="input-instagram">instagram</label>
                  <b-form-input
                  id="input-instagram"
                  class="w-input"
                  v-model="form.instagram"
                  v-bind:class="{'form-control':true, 'is-invalid' : !this.instagramValid}"
                  aria-describedby="input-live-help input-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-live-feedback">
                    {{instagramFeedback}}
                  </b-form-invalid-feedback>
                </b-form-group>

              </b-form>
            </div>
            <div style="width:60%">
              <b-row>
                <b-col  class="text-left">
                  <b-button v-on:click="onPrevious()" class="w-button-pink">{{ translate("previous") }}</b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button v-on:click="onNext()" class="w-button-green">{{ translate("next") }}</b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import NoAccess from './NoAccess.vue'
  import Menu from './MenuDesktop.vue'
  
  import Users from '../Users.js'  

  import Wineries from '../Wineries.js'

  export default {
    name: 'WinerySocialMedia',
    components: {
      NoAccess,
      Menu,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUser() {
        return this.$store.state.user
      },
      currentUserID() {
        return this.$store.state.user_id
      },      
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },        
    },
    data() {
      return {
        debug: false,

        isLoading: true,

        form: {
          address1 : '',
          address2 : '',
          zip : '',
          city : '',
          country : '',

          phone : '',
          email : '',
        },

        countries: [],

        // Validation Logic
        webpageValid : true,
        webpageFeedback : '',
        facebookValid : true,
        facebookFeedback : '',
        twitterValid : true,
        twitterFeedback : '',
        instagramValid : true,
        instagramFeedback : '',

        formValid : true,
      }
    }, 
    async mounted() {
      if (this.debug) console.log('WinerySocialMedia in mounted(): Fetching winery from DB '+ this.$route.query.winery_id);
      
      await Wineries.getone(this.$route.query.winery_id)
      .then(response=>{
        this.form = response;
        delete this.form._id;
        if (this.debug) console.log( "WinerySocialMedia in mounted(): Winery "+ this.form.name + " succesfully fetched from DB");
      })
      .catch(error=>{
        if (this.debug) console.log( "WinerySocialMedia in mounted(): catch await Wineries.getone - ERROR : ", error);
      })

      this.isLoading = false;
    },
    methods: {
      validate(){
        this.formValid = true;
      },  
      async onSave() {
        if(this.formValid){
          //THIS IS WHERE YOU SUBMIT DATA TO SERVER
          await Wineries.update(this.$route.query.winery_id,this.form)
          if (this.debug) console.log("WinerySocialMedia in onSave(): Submitted : ", this.form)
        }
        return 'done' 
      },
      async onNext() {
        await this.onSave()
        .then(response=>{
          if (this.debug) console.log("WinerySocialMedia in onNext():", response)
          this.$store.commit('setPage','Pictures')
          this.$router.push({path:'/Winery/Pictures', query: {winery_id:this.$route.query.winery_id }} );
        })
        
      },
      async onPrevious() {
        await this.onSave()
        .then(response=>{
          if (this.debug) console.log("WinerySocialMedia in onPrevious():", response)
          this.$store.commit('setPage','Contact')
          this.$router.push({path:'/Winery/Contact', query: {winery_id:this.$route.query.winery_id }} );
        }) 
      },
      onReset() {
        this.form.address1 = '';
        this.form.address2 = '';
        this.form.zip = '';
        this.form.city = '';
        this.form.country = '';

        this.form.phone = '';
        this.form.email = '';
        this.form.webpage = '';

        this.form.facebook = '';
        this.form.twitter = '';
        this.form.instagram = '';
      },
      
      async inputCountry(value) {
        this.form.country_id = value;
        for (let i=0; i< this.countries.length; i++) {
          if (this.countries[i].value === value) {
            this.form.country = this.countries[i].text;
          }
        }
        
        if (this.debug) console.log("WinerySocialMedia in inputCountry - country_id = ",this.form.country_id);
        if (this.debug) console.log("WinerySocialMedia in inputCountry - country = ",this.form.country);
      },

      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("TastingsOverview.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('TastingsOverview.selectLanguage: catch await Users.update ERROR : ', error);
      })

        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: STOP");
      },

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      }, 
    }
  }
</script>
